import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeftSidebarComponent } from './left-sidebar/left-sidebar.component';
import { TopbarComponent } from './topbar/topbar.component';
import { FooterComponent } from './footer/footer.component';
import { SimplebarAngularModule } from 'simplebar-angular';
import { NgbAlertModule, NgbCollapseModule, NgbDropdownModule, NgbNavModule, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { ClickOutsideModule } from 'ng-click-outside';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { ChangePasswordModalComponent } from './topbar/change-password-modal/change-password-modal.component';
import {RestaurantSelectionComponent} from "./restaurant-selection/restaurant-selection.component";
import {TranslateModule} from "@ngx-translate/core";


@NgModule({
  declarations: [
    LeftSidebarComponent,
    TopbarComponent,
    FooterComponent,
    ChangePasswordModalComponent,
      RestaurantSelectionComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NgbAlertModule,
    NgbCollapseModule,
    NgbDropdownModule,
    NgbProgressbarModule,
    NgbNavModule,
    SimplebarAngularModule,
    ClickOutsideModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  exports: [
    LeftSidebarComponent,
    TopbarComponent,
    FooterComponent,
    ChangePasswordModalComponent
  ]
})
export class SharedModule { }
